// chartsLogic/utils.js
export const MONTH_CODES = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

/**
 * Dado "2025-11" devuelve "Nov‑25" (o "Noviembre‑25" si cambias months por monthsBreak)
 */
export function formatYm(ym, t, opts = { short: true }) {
	const [year, mm] = ym.split("-");
	const idx = Number(mm) - 1;
	const code = MONTH_CODES[idx] || "unknown";
	const dict = opts.short ? "monthsBreak" : "months";
	// t(`aux.monthsBreak.Nov`) → "Nov"; t(`aux.months.Nov`) → "Noviembre"
	const monthLabel = t(`aux.${dict}.${code}`);
	return `${monthLabel}-${year.slice(2)}`;
}
